module.exports = __webpack_public_path__ + "static/img/KY.226bb625.png";